import { useEffect } from 'react';
import PropTypes from 'prop-types';

export const VIEW_EVENT = 'data-ae-view';
export const ACTION_EVENT = 'data-ae-action';

const viewHandlers = [];
const actionHandlers = [];
const handleEvent = (eventType, eventValue, target) => {
    const handlers = eventType === VIEW_EVENT ? viewHandlers : actionHandlers;

    handlers.forEach((handler) => handler(eventValue, { eventType, target }));
};

let observer;
export const registerViewEventListener = (eventHandler, root = document) => {
    if (!observer) {
        observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                const { addedNodes } = mutation;
                const [target] = addedNodes;

                if (target && target.querySelectorAll) {
                    const elements = target.querySelectorAll(`[${VIEW_EVENT}]`);

                    elements.forEach((el) => {
                        const eventValue = el.getAttribute(VIEW_EVENT);

                        if (eventValue) {
                            handleEvent(VIEW_EVENT, eventValue, el);
                        }
                    });

                    if (target.getAttribute) {
                        const eventValue = target.getAttribute(VIEW_EVENT);

                        if (eventValue) {
                            handleEvent(VIEW_EVENT, eventValue, target);
                        }
                    }
                }
            });
        });

        observer.observe(root, { childList: true, subtree: true });
    }

    if (!viewHandlers.includes(eventHandler)) {
        viewHandlers.push(eventHandler);
    }

    return observer;
};

let isListenerInitialized;
export const registerActionEventListener = (eventHandler, root = document) => {
    if (!isListenerInitialized) {
        isListenerInitialized = true;

        root.addEventListener('pointerdown', (ev) => {
            const { target } = ev;
            const eventValue = target.getAttribute(ACTION_EVENT);

            if (eventValue) {
                handleEvent(ACTION_EVENT, eventValue, target);
            }
        });
    }

    if (!actionHandlers.includes(eventHandler)) {
        actionHandlers.push(eventHandler);
    }

    return isListenerInitialized;
};

const AnalyticObserver = (props) => {
    const { onEvent } = props;

    useEffect(() => {
        registerActionEventListener(onEvent);
        registerViewEventListener(onEvent);

        return () => {
            actionHandlers.splice(actionHandlers.indexOf(onEvent), 1);
            viewHandlers.splice(viewHandlers.indexOf(onEvent), 1);
        };
    }, [onEvent]);

    return (
        <div style={{ display: 'none' }} data-analytic-observer={Date.now()} />
    );
};

AnalyticObserver.propTypes = {
    onEvent: PropTypes.func.isRequired,
};

export default AnalyticObserver;
